<template>
  <Accordion
    :slides="mgnlProps.slides"
    :data-ab-id="mgnlProps?.dataABId"
  />
</template>

<script lang="ts" setup>
import { AccordionBuilder, WrapperProps } from './Accordion.model';
import Accordion from './Accordion.vue';

const props = defineProps(WrapperProps);
const mgnlProps = computed(() => AccordionBuilder.build(props));
</script>
